import Banner from './banner'
import GDPRBannerQuery from './banner.query'

export { GDPRBannerQuery }

export default Banner
